import axios from "axios";
// axios.defaults.timeout = 4000;
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 4000 // request timeout
  })
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8"; //设置编码
service.interceptors.request.use(config => {
        // 是否需要设置 默认都不需要token
        const isToken = (config.headers || {}).isToken === true
        let mobileToken = localStorage.getItem('mobileToken')
        if (isToken && mobileToken) {
            config.headers["Authorization"] = mobileToken;
        }
        return config;
    },
    error => {
        console.log(error)
        return Promise.reject(error);
    }
);
export default service